/* eslint-disable jira/filename-case */
import {
	ContainerTypes,
	type ContainerList,
	type GetContainersDataPlugin,
} from '@atlassiansox/cross-flow-plugins/types';
import { createGetContainersPlugin } from '@atlassiansox/cross-flow-plugins';

import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';

const getCloudId = async (): Promise<ContainerList> => {
	const { cloudName, cloudId } = getTenantContext_DEPRECATED_DO_NOT_USE();

	const containers = [
		{
			id: cloudId,
			displayName: cloudName,
			type: ContainerTypes.ATLASSIAN_CLOUD_ID,
		},
	];

	return {
		type: ContainerTypes.ATLASSIAN_CLOUD_ID,
		containers,
	};
};

export const getContainersPlugin: GetContainersDataPlugin = createGetContainersPlugin(getCloudId);
